import styled from 'styled-components';

export const MembershipColumn = styled.div`
  flex-grow: 1;
  
  &:first-child {
    margin-bottom: 30px;
  }
  
  @media(min-width: 768px) {
    &:first-child {
      margin-bottom: 20px;
    }
  }
  
  @media (min-width: 1024px) {
    width: 50%;
    
    &:first-child {
      margin-bottom: 0;
    }
  }
`;

export const MembershipColumns = styled.div`
  display: flex;
  flex-direction: column;
  
  &:first-child {
    margin-bottom: 40px;
  }
  
  &:last-child ${MembershipColumn}:first-child {
    margin-bottom: 45px;
  }
  
  @media (min-width: 1024px) {
    flex-direction: row;
  }
`;

export const SpecialPerksContainer = styled.div`
  margin-bottom: 5px;
  height: 34px;
`;

export const MembershipHeading = styled.h3`
  margin: 0;
  margin-bottom: 20px;
  padding: 0;
  
  font-size: 24px;
  line-height: 1;
`;

export const RulesList = styled.div`
  a {
    color: ${({ theme }) => theme.blue};
    
    transition: color 0.3s;
    
    &:hover {
      color: ${({ theme }) => theme.black};
    }
  }
  
  li {
    position: relative;
    
    padding-left: 20px;
    
    font-size: 16px;
    line-height: 18px;
    
    &:not(:last-child) {
      margin-bottom: 15px;
    }
    
    &::before {
      content: "";
      
      position: absolute;
      top: 5px;
      left: 0;
      
      width: 6px;
      height: 6px;
      
      background-color: #a8a8a8;
      border-radius: 50%;
    }
  }
`;

export const SpecialPerksBadge = styled.p`
  display: inline-block;
  margin: 0;
  padding: 10px;
  
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
  color: #783004;
  
  background-color: #fbd304;
  border-radius: 20px 0 20px 0;
`;

export const UserInfoColumns = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const UserInfoColumn = styled.div`
  &:first-child {
    width: 45%;
  }
  
  &:last-child {
    width: 55%;
  }
`;

export const UserInfoHeading = styled.h4`
  margin: 0;
  margin-bottom: 5px;
  padding: 0;
  
  font-size: 12px;
  line-height: 1;
`;

export const UserInfoDescription = styled.p`
  margin: 0;
  padding: 0;
  
  font-size: 12px;
  line-height: 18px;
  
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

export const UserInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 35px;
`;

export const CancelSubscriptionButton = styled.button`
  display: flex;
  align-items: center;
  
  font-size: 14px;
  line-height: 1;
  
  transition: color 0.3s;
  
  &:hover {
    color: ${({ theme }) => theme.blue};
  }
  
  svg {
    margin-right: 10px;
    
    fill: currentColor;
    
    transition: fill 0.3s;
  }
`;

export const FaqButton = styled.a`
  margin: 0;
  padding: 0;
  
  font-size: 14px;
  line-height: 1;
  color: inherit;
  
  transition: color 0.3s;
  
  cursor: pointer;
  
  &:hover {
    color: ${({ theme }) => theme.blue};
  }
    
  &::after {
    content: "?";
    
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    padding: 2px 5px;
    
    font-size: 12px;
    line-height: 1;
    
    background-color: ${({ theme }) => theme.lightGray};
    border-radius: 50%;
  }
`;

export const MembershipBadge = styled.article`
  width: 260px;
  height: 125px;
  margin: 0;
  padding: 20px 40px;
  
  font-weight: 700;
  line-height: 1;
  color: #783004;
  
  background: transparent no-repeat center / contain;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='260' height='124' fill='none'%3E%3Cpath fill='url(%23paint0_linear)' fill-rule='evenodd' d='M0 8a8 8 0 0 1 8-8h244a8 8 0 0 1 8 8v39a15 15 0 0 0 0 30v39a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V77a15 15 0 1 0 0-30V8z' clip-rule='evenodd'/%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear' x1='-130' x2='-33.6' y1='62' y2='264' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FBCD00'/%3E%3Cstop offset='1' stop-color='%23FFF318'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E");
  
  filter: drop-shadow(0 4px 16px rgba(252, 207, 1, 0.27));
  
  @media (min-width: 1024px) {
    margin-right: 50px;
  }
`;

export const MembershipBadgeType = styled.h2`
  margin: 0;
  padding: 0;
  margin-bottom: 10px;
  
  font-size: 24px;
`;

export const MembershipBadgeDescription = styled.p`
  margin: 0;
  margin-bottom: 15px;
  padding: 0;
  
  font-size: 12px;
`;

export const MembershipBadgePrice = styled.p`
  margin: 0;
  padding: 0;
  
  font-size: 24px;
  
  span {
    font-weight: 400;
    font-size: 16px;
  }
`;
